
import { MealPlan, DbMealPlan, DailyMealPlans, MealType } from "@/types/mealPlan";
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";
import { authService } from "../auth";

export const mealPlanQueryService = {
  getMealPlans: withErrorHandling(
    async (startDate: Date, endDate: Date): Promise<MealPlan[]> => {
      const startDateStr = startDate.toISOString().split('T')[0];
      const endDateStr = endDate.toISOString().split('T')[0];
      
      console.log(`Fetching meal plans from ${startDateStr} to ${endDateStr}`);

      // Get the current user using the centralized auth service
      const currentUser = await authService.getCurrentUser();
      if (!currentUser) {
        console.log("No authenticated user found");
        throw new Error("No authenticated user found");
      }
      
      // With new RLS policies, we can directly query meal plans
      // The policy will automatically filter to show only accessible meal plans
      const mealPlanResult = await supabase
        .from("meal_plans")
        .select("*, profiles!user_id(first_name)")
        .gte("date", startDateStr)
        .lte("date", endDateStr)
        .order("date", { ascending: true })
        .order("created_at", { ascending: true });

      if (mealPlanResult.error) {
        console.error("Error fetching meal plans:", mealPlanResult.error);
        throw new Error(`Error fetching meal plans: ${mealPlanResult.error.message}`);
      }

      console.log(`Fetched ${mealPlanResult.data?.length || 0} meal plans`);

      // Convert from database format to MealPlan type
      const mealPlans: MealPlan[] = (mealPlanResult.data || []).map((plan: any) => ({
        id: plan.id,
        date: plan.date,
        recipeId: plan.recipe_id,
        mealCompositionId: plan.meal_composition_id,
        mealType: plan.meal_type as MealType,
        createdAt: plan.created_at,
        updatedAt: plan.updated_at,
        familyId: plan.family_id,
        userId: plan.user_id,
        authorFirstName: plan.profiles?.first_name,
      }));

      return mealPlans;
    },
    "Error fetching meal plans"
  )
};
